export default {
  'memberAreaCouponHistory.title': 'Coupon History',
  'memberAreaCouponHistory.time': 'Time',
  'memberAreaCouponHistory.serial_number': 'Serial Number',
  'memberAreaCouponHistory.redeem_store': 'Redemption Store',
  'memberAreaCouponHistory.redeem_no': 'Redemption Number',
} as Record<string, string>;
